import { render, staticRenderFns } from "./basicMsg.vue?vue&type=template&id=d71c62dc&scoped=true"
import script from "./basicMsg.vue?vue&type=script&lang=js"
export * from "./basicMsg.vue?vue&type=script&lang=js"
import style0 from "./basicMsg.vue?vue&type=style&index=0&id=d71c62dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71c62dc",
  null
  
)

export default component.exports